import produce from "immer";
import { MessageDetail } from "../types";
import { MessageDetailsState } from "./messageDetailsState";

export type MessageDetailsActionTypes =
    | { type: "LOAD_MESSAGE" }
    | {
          type: "LOAD_MESSAGE_SUCCESS";
          message: MessageDetail;
          ids: number[];
          currentIndex: number;
      }
    | { type: "NAVIGATE_NEXT" }
    | { type: "NAVIGATE_PREV" }
    | { type: "SET_MESSAGES_READ" }
    | { type: "SET_MESSAGES_UNREAD" }
    | { type: "SET_MESSAGES_READ_SUCCESS" }
    | { type: "SET_MESSAGES_UNREAD_SUCCESS" };

export const messageDetailsReducer = (
    state: MessageDetailsState,
    action: MessageDetailsActionTypes
) =>
    produce(state, draft => {
        switch (action.type) {
            case "LOAD_MESSAGE": {
                draft.loadingMessage = true;
                break;
            }

            case "LOAD_MESSAGE_SUCCESS": {
                draft.currentMessage = action.message;
                draft.loadingMessage = false;
                draft.messageIds = action.ids;
                if (action.currentIndex >= 0) {
                    draft.currentIndex = action.currentIndex;
                }
                if (!action.message.isRead) {
                    draft.currentMessage.isRead = true;
                }
                break;
            }

            case "NAVIGATE_NEXT": {
                const current = draft.currentIndex;
                const count = draft.messageIds.length;
                const number = current + 1;
                if (number <= count) {
                    draft.currentIndex = number;
                }
                break;
            }
            case "NAVIGATE_PREV": {
                const current = draft.currentIndex;
                const number = current - 1;
                if (number >= 0) {
                    draft.currentIndex = number;
                }
                break;
            }
            case "SET_MESSAGES_READ": {
                draft.settingMessageRead = !state.settingMessageRead;
                break;
            }
            case "SET_MESSAGES_UNREAD": {
                draft.settingMessageUnread = !state.settingMessageUnread;
                break;
            }
            case "SET_MESSAGES_READ_SUCCESS": {
                if (draft.currentMessage) {
                    draft.currentMessage.isRead = true;
                }
                break;
            }
            case "SET_MESSAGES_UNREAD_SUCCESS": {
                if (draft.currentMessage) {
                    draft.currentMessage.isRead = false;
                }
                break;
            }
        }
    });
